const th = {
  kicker: "เวอร์ชันทดสอบ",
  title: "เล่น Trollfossjakten ได้เลยตอนนี้ผ่าน Expo Go",
  lead: "เรากำลังทดสอบแอปและสรุปข้อตกลงความร่วมมือ แอปฉบับสมบูรณ์จะเปิดตัวบน App Store และ Google Play ภายในวันที่ 1 กุมภาพันธ์ 2027 ระหว่างนี้คุณเล่นเวอร์ชันทดสอบได้ฟรี",
  notice: "เวอร์ชันทดสอบ — อาจมีการเปลี่ยนแปลงก่อนเปิดตัว",
  step1: "ติดตั้ง Expo Go",
  step1Body: "Expo Go เป็นแอปฟรีที่ใช้เปิดเวอร์ชันทดสอบของเรา ดาวน์โหลดได้จากร้านแอปของคุณ",
  step2: "สแกนโค้ด",
  step2Body: "iPhone: สแกนโค้ดด้วยแอปกล้อง Android: เปิด Expo Go แล้วแตะ “Scan QR code”",
  step3: "หรือเปิดลิงก์บนโทรศัพท์",
  step3Body: "มี Expo Go อยู่แล้วใช่ไหม? แตะปุ่มบนโทรศัพท์เพื่อเปิดเวอร์ชันทดสอบได้ทันที",
  open: "เปิดใน Expo Go",
  copyLink: "คัดลอกลิงก์",
  copied: "คัดลอกลิงก์แล้ว",
  qrAlt: "QR โค้ดสำหรับแอปทดสอบ Trollfossjakten",
  dlTitle: "ดาวน์โหลดเวอร์ชันทดสอบ",
  dlExpo: "1 · ติดตั้ง Expo Go (ฟรี)",
  dlOpen: "2 · เปิดแอปทดสอบของเรา",
  dlLink: "ลิงก์โดยตรง",
  qrCaption: "สแกนเพื่อเปิดเวอร์ชันทดสอบ",
};

export default th;
